import { useEffect } from "react";

import Constants from "@usas/ui-web/utils/Constants";
import useForm from "@usas/ui-web/utils/UseForm";

const useOmeEventsHeaderForm = (onFilterGrid) => {
  const { formState, errorState, onValueTextPairChanged
  } = useForm(getInitialFormState, () => { }, () => { });

  useEffect(() => {
    onFilterGrid(formState.eventId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.eventId]);

  function getInitialFormState() {
    return {
      eventId: Constants.DEFAULT_ID,
      eventName: '',
    };
  }

  return {
    formState,
    errorState,
    onValueTextPairChanged
  };
};

export default useOmeEventsHeaderForm;